import { render } from "./Invoices.vue?vue&type=template&id=06cbab34&scoped=true&ts=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=06cbab34&lang=scss&scoped=true"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cbab34"]])

export default __exports__